
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StrategyProvider } from "@/types/strategy-types";

interface ProviderFieldProps {
  form: UseFormReturn<any>;
  providers: StrategyProvider[];
  isProvider?: boolean;
}

export const ProviderField = ({ form, providers, isProvider }: ProviderFieldProps) => {
  if (isProvider) {
    return (
      <FormField
        control={form.control}
        name="strategy_provider_id"
        render={({ field }) => (
          <FormItem className="hidden">
            <FormControl>
              <Input 
                type="hidden" 
                id="strategy_provider_id" 
                name="strategy_provider_id" 
                {...field} 
              />
            </FormControl>
          </FormItem>
        )}
      />
    );
  }

  return (
    <FormField
      control={form.control}
      name="strategy_provider_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel htmlFor="strategy_provider_id">Provider</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
            defaultValue={field.value}
          >
            <FormControl>
              <SelectTrigger id="strategy_provider_id" name="strategy_provider_id">
                <SelectValue placeholder="Select a provider" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {providers.map((provider) => (
                <SelectItem key={provider.id} value={provider.id}>
                  {provider.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
